import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  go(event) {
    const url = event.currentTarget.value
    if (url) {
      Turbo.visit(url)
    }
  }
}
